// Builds the standards-index navigation cards from the <template data-standard-card>
// rendered by each blocks/standard.liquid. Theme block settings can't be read from
// the parent section, so the cards can't be rendered there directly.
(function () {
  function build(section) {
    const list = section.querySelector('[data-standard-cards]');
    const rows = section.querySelector('[data-standard-rows]');
    if (!list || !rows) return;

    list.replaceChildren(
      ...Array.from(rows.querySelectorAll('template[data-standard-card]'), (template) =>
        template.content.cloneNode(true)
      )
    );
  }

  function init(root) {
    root.querySelectorAll('.standards-index').forEach((section) => {
      build(section);

      if (!window.Shopify || !Shopify.designMode || section.dataset.standardsObserved) return;
      section.dataset.standardsObserved = 'true';

      const rows = section.querySelector('[data-standard-rows]');
      if (!rows) return;
      new MutationObserver(() => build(section)).observe(rows, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
